import { render } from "./cgsCard.vue?vue&type=template&id=64ddb209&scoped=true"
import script from "./cgsCard.vue?vue&type=script&lang=js"
export * from "./cgsCard.vue?vue&type=script&lang=js"

import "./cgsCard.vue?vue&type=style&index=0&id=64ddb209&scoped=true&lang=css"
import "./cgsCard.vue?vue&type=style&index=1&id=64ddb209&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ddb209"]])

export default __exports__